import ApiService from '@common/lib/api/api.service';
import { stringify } from 'query-string';

export const getMainPromotions = () => {
  return ApiService.query('promotion/promotions');
};
